(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section--collection-grid-gallery"] && !Shopify.designMode) return;
  try {
    
class GalleryWallCard extends HTMLElement {
  #activeColour = null;
  #imagePairs = null;
  #swatches = null;
  #swatchContainer = null;
  #productLink = null;
  #boundHandlers = new Map();
  #fadeTimer = null;

  connectedCallback() {
    this.#imagePairs = this.querySelectorAll('[data-variant-colour]');
    this.#swatches = this.querySelectorAll('[data-colour]');
    this.#swatchContainer = this.querySelector('[data-swatch-container]');
    this.#productLink = this.querySelector('[data-product-link]');

    if (this.#swatches.length === 0) return;

    const firstSwatch = this.#swatches[0];
    const initialColour = this.dataset.activeColour;
    this.#activeColour = initialColour || firstSwatch.dataset.colour;

    for (const swatch of this.#swatches) {
      const clickHandler = this.#handleSwatchClick.bind(this);
      const enterHandler = this.#handleSwatchEnter.bind(this);
      const keyHandler = this.#handleKeydown.bind(this);

      swatch.addEventListener('click', clickHandler);
      swatch.addEventListener('mouseenter', enterHandler);
      swatch.addEventListener('keydown', keyHandler);

      this.#boundHandlers.set(swatch, { clickHandler, enterHandler, keyHandler });
    }

    if (this.#swatchContainer) {
      const leaveHandler = this.#handleSwatchLeave.bind(this);
      this.#swatchContainer.addEventListener('mouseleave', leaveHandler);
      this.#boundHandlers.set(this.#swatchContainer, { leaveHandler });
    }
  }

  disconnectedCallback() {
    for (const swatch of this.#swatches) {
      const handlers = this.#boundHandlers.get(swatch);
      if (!handlers) continue;
      swatch.removeEventListener('click', handlers.clickHandler);
      swatch.removeEventListener('mouseenter', handlers.enterHandler);
      swatch.removeEventListener('keydown', handlers.keyHandler);
    }

    if (this.#swatchContainer) {
      const handlers = this.#boundHandlers.get(this.#swatchContainer);
      if (handlers?.leaveHandler) {
        this.#swatchContainer.removeEventListener('mouseleave', handlers.leaveHandler);
      }
    }

    this.#boundHandlers.clear();
    clearTimeout(this.#fadeTimer);
  }

  #handleSwatchClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const swatch = event.currentTarget;
    const colour = swatch.dataset.colour;

    this.#activeColour = colour;
    this.#showVariant(colour);
    this.#updateActiveRing(colour);
    this.#updateProductLink(swatch.dataset.variantId);
  }

  #handleSwatchEnter(event) {
    const colour = event.currentTarget.dataset.colour;
    this.#showVariant(colour);
  }

  #handleSwatchLeave() {
    this.#showVariant(this.#activeColour);
  }

  #handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.#handleSwatchClick(event);
    }
  }

  #showVariant(colour) {
    clearTimeout(this.#fadeTimer);

    for (const pair of this.#imagePairs) {
      if (pair.dataset.variantColour === colour) {
        pair.style.zIndex = '1';
        pair.classList.remove('opacity-0', 'pointer-events-none');
      }
    }

    this.#fadeTimer = setTimeout(() => {
      for (const pair of this.#imagePairs) {
        if (pair.dataset.variantColour !== colour) {
          pair.classList.add('opacity-0', 'pointer-events-none');
        }
        pair.style.zIndex = '';
      }
    }, 300);
  }

  #updateActiveRing(colour) {
    for (const swatch of this.#swatches) {
      const isActive = swatch.dataset.colour === colour;
      swatch.classList.toggle('ring-stone-900', isActive);
      swatch.classList.toggle('ring-transparent', !isActive);
    }
  }

  #updateProductLink(variantId) {
    if (!this.#productLink || !variantId) return;
    const baseUrl = this.#productLink.getAttribute('href').split('?')[0];
    this.#productLink.setAttribute('href', `${baseUrl}?variant=${variantId}`);
  }
}

customElements.define('gallery-wall-card', GalleryWallCard);

(function () {
  const SECTION_SELECTOR = '.collection-grid-gallery';
  const FILTER_SELECTOR = '[data-filter-param]';
  let controller = null;

  document.addEventListener('click', (event) => {
    const link = event.target.closest(FILTER_SELECTOR);
    if (!link) return;

    const section = link.closest(SECTION_SELECTOR);
    if (!section) return;

    event.preventDefault();

    const param = link.dataset.filterParam;
    const value = link.dataset.filterValue;
    const baseUrl = section.dataset.collectionUrl || window.location.pathname;
    const url = buildFilterUrl(baseUrl, param, value);

    loadFilteredSection(section, url, true);
  });

  window.addEventListener('popstate', () => {
    const section = document.querySelector(SECTION_SELECTOR);
    if (section) loadFilteredSection(section, window.location.href, false);
  });

  function buildFilterUrl(baseUrl, toggleParam, toggleValue) {
    const params = new URLSearchParams(window.location.search);

    if (!toggleValue) {
      params.delete(toggleParam);
    } else if (params.get(toggleParam) === toggleValue) {
      params.delete(toggleParam);
    } else {
      params.set(toggleParam, toggleValue);
    }

    const qs = params.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
  }

  async function loadFilteredSection(section, url, pushState) {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    section.style.opacity = '0.5';
    section.style.pointerEvents = 'none';
    section.style.transition = 'opacity 150ms';

    controller?.abort();
    controller = new AbortController();

    try {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('sections', sectionId);

      const response = await fetch(fetchUrl, { signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      const html = data[sectionId];

      const temp = new DOMParser().parseFromString(html, 'text/html');
      const newSection = temp.querySelector('section');

      if (newSection) {
        section.innerHTML = newSection.innerHTML;
        for (const attr of newSection.attributes) {
          section.setAttribute(attr.name, attr.value);
        }
      }

      if (pushState) history.pushState({}, '', url);
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.location.href = url;
      }
    } finally {
      section.style.opacity = '';
      section.style.pointerEvents = '';
      section.style.transition = '';
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--gallery-wall-floating-bar"] && !Shopify.designMode) return;
  try {
    
class GalleryWallBar extends HTMLElement {
  #wasVisible = false;

  #heroEl = null;

  #onScroll = () => {
    this.#checkVisibility();
  };

  #checkVisibility() {
    if (!this.#heroEl || !this.#heroEl.isConnected) {
      this.#heroEl = document.querySelector('gallery-wall-hero');
    }
    if (!this.#heroEl) return;

    const heroBottom = this.#heroEl.getBoundingClientRect().bottom;
    const isVisible = heroBottom < window.innerHeight * 0.85;

    if (isVisible !== this.#wasVisible) {
      this.classList.toggle('gallery-wall-bar--visible', isVisible);

      if (isVisible) {
        const line = this.querySelector('.gallery-wall-bar__cta-underline');
        if (line) {
          line.classList.remove('gallery-wall-bar__cta-underline--animate');
          void line.getBoundingClientRect();
          line.classList.add('gallery-wall-bar__cta-underline--animate');
        }
      }
    }
    this.#wasVisible = isVisible;
  }

  #onClickOutside = (event) => {
    if (!this.contains(event.target)) {
      this.#closePanel();
    }
  };

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    this.swatches = this.querySelectorAll('.gallery-wall-bar__swatch');
    this.sizeBtns = this.querySelectorAll('.gallery-wall-bar__size-btn');
    this.colourName = this.querySelector('[data-colour-name]');
    this.uploadLink = this.querySelector('[data-upload-link]');
    this.priceEl = this.querySelector('[data-cta-price]');
    this.productHandle = this.dataset.productHandle;

    for (const swatch of this.swatches) {
      swatch.addEventListener('click', this.#handleSwatchClick.bind(this));
    }

    for (const btn of this.sizeBtns) {
      btn.addEventListener('click', this.#handleSizeClick.bind(this));
    }

    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('scrollend', this.#onScroll, { passive: true });
    this.#checkVisibility();

    const cta = this.querySelector('.gallery-wall-bar__cta');
    if (cta) {
      cta.addEventListener('mouseenter', () => {
        const line = this.querySelector('.gallery-wall-bar__cta-underline');
        if (line) {
          line.classList.remove('gallery-wall-bar__cta-underline--animate');
          void line.getBoundingClientRect();
          line.classList.add('gallery-wall-bar__cta-underline--animate');
        }
      });
    }

    const detailsToggle = this.querySelector('[data-details-toggle]');
    if (detailsToggle) {
      detailsToggle.addEventListener('click', () => this.#togglePanel());
    }

    document.addEventListener('gallery-wall:colour-change', (event) => {
      if (event.detail.source === 'bar') return;
      this.#syncColour(event.detail.colour, event.detail);
    });

    document.addEventListener('gallery-wall:size-change', (event) => {
      this.#syncSize(event.detail.size, event.detail);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('scrollend', this.#onScroll);
    document.removeEventListener('click', this.#onClickOutside);
  }

  #togglePanel() {
    if (this.classList.contains('gallery-wall-bar--details-open')) {
      this.#closePanel();
    } else {
      this.classList.add('gallery-wall-bar--details-open');
      requestAnimationFrame(() => {
        document.addEventListener('click', this.#onClickOutside);
      });
    }
  }

  #closePanel() {
    this.classList.remove('gallery-wall-bar--details-open');
    document.removeEventListener('click', this.#onClickOutside);
  }

  #syncColour(colour, detail) {
    const matchingSwatch = this.querySelector(`.gallery-wall-bar__swatch[data-colour="${colour}"]`);
    if (!matchingSwatch) return;

    for (const s of this.swatches) {
      s.classList.remove('gallery-wall-bar__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    }
    matchingSwatch.classList.add('gallery-wall-bar__swatch--active');
    matchingSwatch.setAttribute('aria-pressed', 'true');

    if (this.colourName) {
      this.colourName.textContent = colour;
    }

    if (this.priceEl && detail.price) {
      this.priceEl.textContent = detail.price;
    }

    if (this.uploadLink && detail.sku) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${detail.sku}`;
    }

    for (const section of this.querySelectorAll('[data-panel-colour]')) {
      section.classList.toggle('gallery-wall-bar__panel-section--hidden', section.dataset.panelColour !== colour);
    }
  }

  #handleSizeClick(event) {
    const btn = event.currentTarget;
    const size = btn.dataset.size;

    for (const b of this.sizeBtns) {
      b.classList.remove('gallery-wall-bar__size-btn--active');
      b.setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('gallery-wall-bar__size-btn--active');
    btn.setAttribute('aria-pressed', 'true');

    document.dispatchEvent(new CustomEvent('gallery-wall:size-change', {
      detail: { size },
      bubbles: false
    }));
  }

  #syncSize(size, detail) {
    const matchingBtn = this.querySelector(`.gallery-wall-bar__size-btn[data-size="${size}"]`);
    if (!matchingBtn) return;

    for (const b of this.sizeBtns) {
      b.classList.remove('gallery-wall-bar__size-btn--active');
      b.setAttribute('aria-pressed', 'false');
    }
    matchingBtn.classList.add('gallery-wall-bar__size-btn--active');
    matchingBtn.setAttribute('aria-pressed', 'true');

    if (this.priceEl && detail.price) {
      this.priceEl.textContent = detail.price;
    }
    if (this.uploadLink && detail.sku) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${detail.sku}`;
    }
  }

  #handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const colour = swatch.dataset.colour;
    const sku = swatch.dataset.variantSku;
    const price = swatch.dataset.variantPrice;

    for (const s of this.swatches) {
      s.classList.remove('gallery-wall-bar__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    }
    swatch.classList.add('gallery-wall-bar__swatch--active');
    swatch.setAttribute('aria-pressed', 'true');

    if (this.colourName) {
      this.colourName.textContent = colour;
    }

    if (this.priceEl && price) {
      this.priceEl.textContent = price;
    }

    if (this.uploadLink && sku) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${sku}`;
    }

    for (const section of this.querySelectorAll('[data-panel-colour]')) {
      section.classList.toggle('gallery-wall-bar__panel-section--hidden', section.dataset.panelColour !== colour);
    }

    document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
      detail: { colour, sku, price, source: 'bar' },
      bubbles: false
    }));
  }
}

customElements.define('gallery-wall-bar', GalleryWallBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--gallery-wall-hero"] && !Shopify.designMode) return;
  try {
    
class GalleryWallHero extends HTMLElement {
  #currentColour = '';
  #currentSize = '';
  #variants = [];

  connectedCallback() {
    const jsonEl = this.querySelector('[data-variant-json]');
    if (jsonEl) {
      try { this.#variants = JSON.parse(jsonEl.textContent); } catch {}
    }

    this.swatches = this.querySelectorAll('.gallery-wall-hero__swatch');
    this.sizeBtns = this.querySelectorAll('.gallery-wall-hero__size-btn');
    this.panelSections = this.querySelectorAll('[data-hero-panel-colour]');
    this.colourName = this.querySelector('[data-hero-colour-name]');
    this.uploadLink = this.querySelector('[data-hero-upload-link]');
    this.priceEl = this.querySelector('[data-hero-price]');
    this.comparePriceEl = this.querySelector('[data-hero-compare-price]');
    this.saveTagEl = this.querySelector('[data-hero-save-tag]');
    this.afterpayEl = this.querySelector('[data-hero-afterpay-price]');
    this.dimensionsEl = this.querySelector('[data-hero-dimensions]');
    this.specsDimensionsEl = this.querySelector('[data-hero-specs-dimensions]');
    this.productHandle = this.dataset.productHandle;

    const activeSwatch = this.querySelector('.gallery-wall-hero__swatch--active');
    if (activeSwatch) this.#currentColour = activeSwatch.dataset.colour;

    const activeSize = this.querySelector('.gallery-wall-hero__size-btn--active');
    if (activeSize) this.#currentSize = activeSize.dataset.size;

    for (const swatch of this.swatches) {
      swatch.addEventListener('click', this.#handleSwatchClick.bind(this));
    }

    for (const btn of this.sizeBtns) {
      btn.addEventListener('click', this.#handleSizeClick.bind(this));
    }

    this.#initDispatchDate();

    document.addEventListener('gallery-wall:colour-change', (event) => {
      if (event.detail.source === 'hero') return;
      this.#syncColour(event.detail.colour, event.detail);
    });

    document.addEventListener('gallery-wall:size-change', (event) => {
      if (event.detail.source === 'hero') return;
      this.#syncSize(event.detail.size);
    });
  }

  #handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const colour = swatch.dataset.colour;
    this.#currentColour = colour;

    this.#setActiveSwatches(swatch);
    this.#updateHeroImages(colour);
    this.#updatePanels(colour);

    const variant = this.#resolveVariant();
    this.#updateCta(variant);

    document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
      detail: { colour, sku: variant?.sku, price: variant?.price, source: 'hero' },
      bubbles: false
    }));
  }

  #handleSizeClick(event) {
    const btn = event.currentTarget;
    this.#currentSize = btn.dataset.size;

    for (const b of this.sizeBtns) {
      b.classList.remove('gallery-wall-hero__size-btn--active');
      b.setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('gallery-wall-hero__size-btn--active');
    btn.setAttribute('aria-pressed', 'true');

    const variant = this.#resolveVariant();
    this.#updateCta(variant);

    document.dispatchEvent(new CustomEvent('gallery-wall:size-change', {
      detail: { size: this.#currentSize, sku: variant?.sku, price: variant?.price, source: 'hero' },
      bubbles: false
    }));

    if (variant) {
      document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
        detail: { colour: this.#currentColour, sku: variant.sku, price: variant.price, source: 'hero' },
        bubbles: false
      }));
    }
  }

  #syncSize(size) {
    this.#currentSize = size;
    const matchingBtn = this.querySelector(`.gallery-wall-hero__size-btn[data-size="${size}"]`);
    if (matchingBtn) {
      for (const b of this.sizeBtns) {
        b.classList.remove('gallery-wall-hero__size-btn--active');
        b.setAttribute('aria-pressed', 'false');
      }
      matchingBtn.classList.add('gallery-wall-hero__size-btn--active');
      matchingBtn.setAttribute('aria-pressed', 'true');
    }

    const variant = this.#resolveVariant();
    this.#updateCta(variant);

    if (variant) {
      document.dispatchEvent(new CustomEvent('gallery-wall:size-change', {
        detail: { size, sku: variant.sku, price: variant.price, source: 'hero' },
        bubbles: false
      }));
      document.dispatchEvent(new CustomEvent('gallery-wall:colour-change', {
        detail: { colour: this.#currentColour, sku: variant.sku, price: variant.price, source: 'hero' },
        bubbles: false
      }));
    }
  }

  #syncColour(colour, detail) {
    this.#currentColour = colour;
    const matchingSwatch = this.querySelector(`.gallery-wall-hero__swatch[data-colour="${colour}"]`);
    if (matchingSwatch) {
      this.#setActiveSwatches(matchingSwatch);
      this.#updateHeroImages(colour);
      this.#updatePanels(colour);
    }
    const variant = this.#resolveVariant();
    this.#updateCta(variant);
  }

  #resolveVariant() {
    if (this.#variants.length === 0) return null;

    if (this.#currentSize && this.#currentColour) {
      const match = this.#variants.find(v => v.colour === this.#currentColour && v.size === this.#currentSize);
      if (match) return match;
    }

    if (this.#currentColour) {
      const match = this.#variants.find(v => v.colour === this.#currentColour);
      if (match) return match;
    }

    if (this.#currentSize) {
      const match = this.#variants.find(v => v.size === this.#currentSize);
      if (match) return match;
    }

    return this.#variants[0];
  }

  #initDispatchDate() {
    const el = this.querySelector('[data-dispatch-days]');
    if (!el) return;
    const label = el.querySelector('[data-dispatch-label]');
    if (!label) return;

    const days = el.dataset.dispatchDays;
    const setLabel = () => {
      if (typeof window.getDispatchDate === 'function') {
        const result = window.getDispatchDate(days);
        label.textContent = `Order now, dispatched by ${result.long}`;
      }
    };

    if (typeof window.getDispatchDate === 'function') {
      setLabel();
    } else {
      window.addEventListener('load', setLabel);
    }
  }

  #setActiveSwatches(activeSwatch) {
    for (const s of this.swatches) {
      s.classList.remove('gallery-wall-hero__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    }
    activeSwatch.classList.add('gallery-wall-hero__swatch--active');
    activeSwatch.setAttribute('aria-pressed', 'true');

    if (this.colourName) {
      this.colourName.textContent = activeSwatch.dataset.colour;
    }
  }

  #updateHeroImages(colour) {
    for (const layer of this.querySelectorAll('[data-hero-colour]')) {
      layer.classList.toggle('gallery-wall-hero__layer--hidden', layer.dataset.heroColour !== colour);
    }
  }

  #updatePanels(colour) {
    for (const section of this.panelSections) {
      section.classList.toggle('gallery-wall-hero__frame-section--hidden', section.dataset.heroPanelColour !== colour);
    }
  }

  #updateCta(variant) {
    if (!variant) return;
    if (this.uploadLink) {
      this.uploadLink.href = `/apps/frame/gallery-walls/${this.productHandle}/styles/${variant.sku}`;
    }
    if (this.priceEl) {
      this.priceEl.textContent = variant.price;
    }
    if (this.comparePriceEl) {
      if (variant.compareAtPrice) {
        this.comparePriceEl.textContent = variant.compareAtPrice;
        this.comparePriceEl.classList.remove('gallery-wall-hero__compare-price--hidden');
      } else {
        this.comparePriceEl.textContent = '';
        this.comparePriceEl.classList.add('gallery-wall-hero__compare-price--hidden');
      }
    }
    if (this.saveTagEl) {
      if (variant.compareAtPrice) {
        const numericPrice = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
        const numericCompare = parseFloat(variant.compareAtPrice.replace(/[^0-9.]/g, ''));
        const savePct = Math.round((numericCompare - numericPrice) / numericCompare * 100);
        this.saveTagEl.textContent = `Save ${savePct}% with bundle`;
        this.saveTagEl.classList.remove('gallery-wall-hero__save-tag--hidden');
      } else {
        this.saveTagEl.textContent = '';
        this.saveTagEl.classList.add('gallery-wall-hero__save-tag--hidden');
      }
    }
    if (this.afterpayEl) {
      const numericPrice = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
      if (!Number.isNaN(numericPrice)) {
        const installment = (numericPrice / 4).toFixed(2);
        const formatted = variant.price.replace(/[\d,.]+/, installment.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        this.afterpayEl.textContent = formatted;
      }
    }
    if (variant.width && variant.height) {
      const dimHtml = `${variant.width} &times; ${variant.height} cm`;
      if (this.dimensionsEl) this.dimensionsEl.innerHTML = dimHtml;
      if (this.specsDimensionsEl) this.specsDimensionsEl.innerHTML = dimHtml;
    }
  }
}

customElements.define('gallery-wall-hero', GalleryWallHero);

  } catch(e) { console.error(e); }
})();
})();
